import { GetDuePaymentsRequest } from "../api/requests/get-due-payments-request";
import { ErrorResponseWrapper } from "../api/errors/error-response-wrapper";
import config from "../environment/environment-config";

export const FINACIALS_BASE_URL = config.apiUrls.financialsApi;

export const FETCH_DUE_PAYMENTS_BEGIN = "FETCH_DUE_PAYMENTS_BEGIN";
export const FETCH_DUE_PAYMENTS_SUCCESS = "FETCH_DUE_PAYMENTS_SUCCESS";
export const FETCH_DUE_PAYMENTS_FAILURE = "FETCH_DUE_PAYMENTS_FAILURE";

export const fetchDuePaymentsBegin = (request) => ({
  type: FETCH_DUE_PAYMENTS_BEGIN,
  payload: request,
});

export const fetchDuePaymentsSuccess = (duePaymentsResponse) => ({
  type: FETCH_DUE_PAYMENTS_SUCCESS,
  payload: { duePaymentsResponse },
});

export const fetchDuePaymentsFailure = (errors) => ({
  type: FETCH_DUE_PAYMENTS_FAILURE,
  payload: { errors },
});

/**
 * @jsdoc method
 * @name getCreditLimit
 * @methodOf actions.financialsActions
 * @description description
 * Fetches credit limit informations of currently logged in user
 */
export function getCreditLimit() {
  return fetch(`${FINACIALS_BASE_URL}/credit-limit`, {
    credentials: "same-origin",
  }).then((res) => {
    if (!res.ok) {
      throw new Error();
    }
    return res.json();
  });
}

/**
 * @jsdoc method
 * @name getBankSlip
 * @methodOf actions.financialsActions
 * @description description
 * Generate bank slip html based on open installment data
 */
export function getBankSlip(paymentData) {
  return fetch(`${FINACIALS_BASE_URL}/bank-slip`, {
    credentials: "same-origin",
    method: "POST",
    body: JSON.stringify(paymentData),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error();
      }
      return res.json();
    })
    .then((data) => {
      return data.html;
    });
}

/**
 * @jsdoc method
 * @name getDuePayments
 * @methodOf actions.financialsActions
 * @description description
 * Get due payments
 */
export function getDuePayments(request: GetDuePaymentsRequest) {
  const url = `${FINACIALS_BASE_URL}/due-payments${request.toQueryString()}`;
  return (dispatch) => {
    dispatch(fetchDuePaymentsBegin(request));
    return fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) {
          throw new ErrorResponseWrapper(res);
        }
        return res.json();
      })
      .then((data) => {
        dispatch(fetchDuePaymentsSuccess(data));
      })
      .catch((errorResponse: ErrorResponseWrapper) => {
        errorResponse.getErrorMessages().then((messages) => {
          dispatch(fetchDuePaymentsFailure(messages));
        });
      });
  };
}
